// src/client/utils/validation.ts
import { NRC_REGEX } from '@/constants/config';

// Zambia mobile: 9-digit local number whose first digit is 7 or 9.
// Covers current ZICTA allocations (MTN 76x/96x, Airtel 77x/97x, Zamtel 75x/95x)
// and any future allocations in the 70-79 / 90-99 range.
// Landlines start with 21x/22x etc., so first-digit check is sufficient.
const ZAMBIA_LOCAL_REGEX = /^[79]\d{8}$/;

/**
 * Strip non-digits and reduce to the canonical 9-digit local body, but only
 * if the body matches a supported carrier prefix. Returns null otherwise so
 * callers don't accept inputs the validator rejects.
 */
function extractValidLocal(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const digits = raw.replace(/\D/g, '');
  let local: string;
  if (digits.startsWith('260') && digits.length === 12) local = digits.slice(3);
  else if (digits.length === 10 && digits.startsWith('0')) local = digits.slice(1);
  else if (digits.length === 9) local = digits;
  else return null;
  return ZAMBIA_LOCAL_REGEX.test(local) ? local : null;
}

export function formatZambiaPhone(raw: string | null | undefined): string {
  if (!raw) return '—';
  const local = extractValidLocal(raw);
  if (!local) return '—';
  return `+260 ${local.slice(0, 2)} ${local.slice(2, 5)} ${local.slice(5)}`;
}

export function isValidZambiaPhone(raw: string | null | undefined): boolean {
  return extractValidLocal(raw) !== null;
}

export function normalizeZambiaPhone(raw: string): string | null {
  const local = extractValidLocal(raw);
  return local ? `+260${local}` : null;
}

export function isValidNRC(raw: string): boolean {
  return NRC_REGEX.test(raw.trim());
}
